import { useTexts } from '../hooks/useTexts'
import { createValidateUsername } from '../hooks/validations/createValidateUsername'
import { useIsUsernameAvailable } from '../hooks/useIsUsernameAvailable'

import { form } from '../formState'

export function Username() {
  const texts = useTexts()
  const isAvailableUsername = useIsUsernameAvailable()
  const formApi = form.useFormApi()
  const initialValue = formApi.getInitialValues()

  form.useAddFieldValidation<'username'>('username', async (field, _formApi) => {
    const validationUserName = await createValidateUsername(
      texts,
      field.value,
      isAvailableUsername,
      initialValue.username,
    )
    return (
      validationUserName.usernameRequiredError?.message ||
      validationUserName.usernameUniqueError?.message ||
      validationUserName.usernameMinLengthError?.message ||
      validationUserName.usernameMaxLengthError?.message
    )
  })

  return (
    <form.TextField
      name="username"
      testId="username"
      label={texts.labels.username}
      validateOn="change"
    />
  )
}
